import fetch from '../../httpService/fetch';

//获取当前权限
const flowBaeUrl = '/grt-pageflow-service/flow/process/v1',
    getBehaviorListUrl = '/grt-pageflow-service/flow/config/v1/node-info',
    //查询当前启用的工作流程id
    getFlowIdUrl = '/grt-application-service/application/webpage/v1/lastest/',
    //查询流程节点
    getFlowNodeUrl = flowBaeUrl + '/flow-node',
    //发起审批
    initiateApprovalUrl = flowBaeUrl + '/start',
    //保存
    saveUrl = flowBaeUrl + '/form-data/save',
    //获取表单信息
    getFormDataUrl = '/common-handle-task/task/v1/';

export function getBehaviorListReq(params) {
    return fetch.get(getBehaviorListUrl, params);
}

export function getFlowIdReq(id) {
    return fetch.get(getFlowIdUrl + id);
}

export function getFlowNodeReq(params) {
    return fetch.get(getFlowNodeUrl, params);
}

export function initiateApprovalReq(data) {
    return fetch.post(initiateApprovalUrl, data);
}

export function saveReq(data) {
    return fetch.post(saveUrl, data);
}

export function getFormDataReq(id) {
    return fetch.get(getFormDataUrl + id);
}
